<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small swb-btn-small" v-if="!showDetail && !quantityFlag" @click="addAppliedShop()">新增门店</button>
            </div>
            <div class="right">
                <button class="swb-btn swb-btn-small swb-btn-small" v-if="quantityFlag && !showDetail" @click="setQuantity()">批量设置服务次数</button>
                <a class="swb-btn-link" v-if="!showDetail" @click="downloadTemplate">下载导入模板</a>
                <a class="swb-btn-link" v-if="!showDetail" @click="doUpload">导入机构价格</a>
            </div>
        </div>
        <el-table :data="selectComList" border style="width: 100%" height="565">
            <el-table-column type="index" label="行号" align="center" width="50"></el-table-column>
            <el-table-column prop="bizUnitName" label="业务单元" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizAreaName" label="经营区域" width="140" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizFormName" label="经营业态" align="left" width="140"></el-table-column>
            <el-table-column prop="mgmtSmlAreaName" label="管理区域" align="left" width="140"></el-table-column>
            <el-table-column prop="quantity" label="服务次数" align="left" width="140" v-if="quantityFlag">
                <template slot-scope="rows">
                    <el-input type="number" :min="0" v-model.number="rows.row.quantity" :disabled="showDetail || (!quantityRevisible && rows.row.id != null && !bianengFlag)" @change="changeQuantity(rows.$index)"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="quantityUsed" label="已服务次数" align="left" width="100" v-if="quantityFlag">
                <template slot-scope="rows">
                    <span>{{rows.row.quantityUsed || 0}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="priceSpecFlag" label="价格规则" width="160" align="left">
                <template slot-scope="rows">
                    <el-select v-model="rows.row.priceSpecFlag" :disabled="showDetail" @change="changePriceSpecFlag(rows.$index)">
                        <el-option v-for="priceSpecItem in priceSpecFlagList" :label="priceSpecItem.text" :value="priceSpecItem.value" :disabled="(servcModify || bianengFlag) && rows.row.id != null && priceSpecItem.value == 2 && rows.row.srcPriceSpecFlag != 2"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="单次服务价格" width="120" align="left">
                <template slot-scope="rows">
                    <el-input type="number" :min="0" v-model.number="rows.row.price" @change="priceChange(rows.$index)" :disabled="showDetail" v-if="rows.row.priceSpecFlag == 1"></el-input>
                </template>
            </el-table-column>
            <el-table-column prop="amount" label="机构总价" width="120" align="left">
                <template slot-scope="rows">
                    <el-input type="number" :min="0" v-model.number="rows.row.amount" @change="amountChange(rows.$index)" :disabled="showDetail || !amountFlag || rows.row.priceSpecFlag != 2 || rows.row.quantity <= rows.row.quantityUsed2"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="160">
                <template slot-scope="rows">
                    <a class="swb-btn swb-btn-link" v-if="!(servcModify || showDetail) && !quantityFlag" @click="removeComInfo(rows.$index)">移除</a>
                    <a class="swb-btn swb-btn-link" v-if="rows.row.priceSpecFlag == 2" @click="showPriceRec(rows.$index)">单次价格预览</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { MsgBox } from '../../app.vues'
    import retailerApi from '../../api/retailer'
    import { openRetailerComListForSelectDlg } from '../retailer/selectDlg';
    import { openShowContractServcOrgPriceRecListDlg } from './dialog';
    import { fileUploadGroupShowDlg } from '../comn/dialog';
    import contractApi from '../../api/contract';

    export default {
        name: 'swb-contract-servc-org-spec-list',
        desc: '合同服务机构特定设置',
        props: [
            'comnRequire',
            'quantityFlag',     // 是否支持服务次数
            'quantityRevisible',//  服务次数允许修订
            'amountFlag',   // 是否支持机构总价

            'showDetail',
            'servcOrgSpecList',
            'contractAppliedShopList',
            'servcModify',  // servcModify: 合同修订
            'bianengFlag',  // bianengFlag: 合同变更
            'filterMerchantId'],
        data: function () {
            return {
                priceSpecFlagList: [],
                selectComList: []
            }
        },
        created: function () {
            let self = this;
            if(this.servcOrgSpecList.length > 0) { // 编辑的
                let selectComList = Utils.merge([], this.servcOrgSpecList);
                for(let i = 0; i < selectComList.length; i++) {
                    let comInfo = selectComList[i];
                    comInfo.srcPriceSpecFlag = comInfo.priceSpecFlag;
                    if(Utils.isNoB(comInfo.quantity)) {
                        comInfo.quantity = 0;
                    } else {
                        comInfo.srcQuantity = comInfo.quantity;
                    }
                }
                this.selectComList = Utils.merge([], selectComList);
            } else {
                // 支持服务次数自动选中所有的门店
                if(Utils.isTrue(this.quantityFlag)) {
                    let contractAppliedShopList = this.contractAppliedShopList || [];
                    if(contractAppliedShopList.length <= 0) {
                        MsgBox.warning('请先选择适用机构');
                        return false;
                    }
                    let postData = {
                        ids: contractAppliedShopList.pluck('shopId')
                    };
                    let theLoad = MsgBox.loading();
                    retailerApi.getRetailerComByIds(postData, function (resultData) {
                        self.makeSelectComList(resultData.data || [], theLoad);
                    });
                }
            }
            //
            let priceSpecFlagList = getEnumList('priceSpecFlag');
            for(let i = 0; i < priceSpecFlagList.length; i++) {
                if((!this.quantityFlag || !this.amountFlag) && priceSpecFlagList[i].value == 2) {    // 移除总价控制
                    priceSpecFlagList.splice(i, 1);
                    break;
                }
            }
            this.priceSpecFlagList = Utils.merge([], priceSpecFlagList);
        },
        methods: {
            addAppliedShop: function () {
                let self = this;
                let contractAppliedShopList = this.contractAppliedShopList || [];
                if(contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let selectComList = this.selectComList || [];
                let queryFilter = {
                    disabledIds: selectComList.pluck('bizUnitId'),
                    ids: contractAppliedShopList.pluck('shopId'),
                    filterMerchantId: self.filterMerchantId
                };
                openRetailerComListForSelectDlg(queryFilter, function (comList, theDlg) {
                    theDlg.close();
                    self.makeSelectComList(comList, theDlg);
                });
            },
            makeSelectComList: function (comList, theLoad) {
                let self = this;
                let selectComList = this.selectComList || [];
                if(comList.length > 0) {
                    for(let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        selectComList.push({
                            bizUnitId: comInfo.id,
                            bizUnitName: comInfo.name,
                            shopFlag: comInfo.shopFlag,
                            bizAreaId: comInfo.bizAreaId,
                            bizAreaName: comInfo.bizAreaName,
                            bizFormId: comInfo.bizFormId,
                            bizFormName: comInfo.bizFormName,
                            mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                            mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                            //
                            priceSpecFlag: 0,
                            price: 0.00,
                            toDoorFee: 0.00,
                            quantitySpecFlag: this.quantityFlag,
                            quantity: 0,
                            srcQuantity: 0,
                            amount: 0.00
                        });
                    }
                }
                theLoad.close();
                self.selectComList = Utils.merge([], selectComList);
            },
            priceChange: function (index) {
                let selectComList = this.selectComList;
                let selectCom = selectComList[index];
                if(!Utils.isMoneyStr(selectCom.price) || selectCom.price < 0) {
                    selectCom.price = 0.00;
                    MsgBox.warning('请输入正确的价格');
                    return;
                } else {
                    selectCom.price = Utils.isNoB(selectCom.price) ? null : parseFloat(selectCom.price).toFixed(2);
                }
                if(!Utils.isNoB(selectCom.quantity) && selectCom.quantity > 0) {
                    selectCom.amount = parseFloat(selectCom.price * selectCom.quantity).toFixed(2)
                }
                this.selectComList = Utils.merge([], selectComList);
            },
            amountChange: function (index) {
                let selectComList = this.selectComList;
                let selectCom = selectComList[index];
                if(!Utils.isMoneyStr(selectCom.amount) || selectCom.amount < 0) {
                    selectCom.amount = 0.00;
                    MsgBox.warning('请输入正确的机构总价');
                }
                let amount = Utils.isNoB(selectCom.amount) ? null : parseFloat(selectCom.amount).toFixed(2);
                if((this.servcModify || this.bianengFlag) && selectCom.priceSpecFlag == 2 && !Utils.isNoB(selectCom.amountUsed) && amount < selectCom.amountUsed2) {   // 修订
                    selectCom.amount = selectCom.amountUsed2;
                    MsgBox.warning("机构总价不可小于已发生总价：" + selectCom.amountUsed2);    // 只提示不 return ,继续执行下面的计算单价
                } else {
                    selectCom.amount = amount;
                }
                // 计算单价
                let amountUsed2 = selectCom.amountUsed2 || 0.00;
                let quantityUsed2 = selectCom.quantityUsed2 || 0;
                if(!Utils.isNoB(selectCom.quantity) && selectCom.quantity > 0) {
                    selectCom.price = parseFloat((selectCom.amount - amountUsed2) / (selectCom.quantity - quantityUsed2)).toFixed(2)
                }
                this.selectComList = Utils.merge([], selectComList);
            },
            changeQuantity: function (index) {
                let selectComList = this.selectComList || [];
                let selectCom = selectComList[index];
                if(selectCom.quantity < 0 || !Utils.isNumber(selectCom.quantity)) {
                    selectCom.quantity = 0;
                    MsgBox.warning('请输入正整数');
                }
                if((this.servcModify || this.bianengFlag) && !Utils.isNoB(selectCom.id) && selectCom.quantity < selectCom.quantityUsed) {
                    selectCom.quantity = selectCom.quantityUsed;
                    MsgBox.warning('不可小于已发生次数：' + selectCom.quantityUsed);
                }
                let amountUsed2 = selectCom.amountUsed2 || 0.00;
                let quantityUsed2 = selectCom.quantityUsed2 || 0;
                if(selectCom.priceSpecFlag == 2) { // 总价
                    // 计算单价
                    if(!Utils.isNoB(selectCom.amount) && selectCom.amount > 0) {
                        if(selectCom.quantity <= quantityUsed2) {
                            selectCom.price = 0.00;
                            selectCom.amount = amountUsed2;
                        } else {
                            selectCom.price = parseFloat((selectCom.amount - amountUsed2) / (selectCom.quantity - quantityUsed2)).toFixed(2);
                        }
                    }
                } else if(selectCom.priceSpecFlag == 1) {    // 单价
                    // 计算总价
                    if(!Utils.isNoB(selectCom.price) && selectCom.price > 0) {
                        selectCom.amount = parseFloat(selectCom.price * selectCom.quantity).toFixed(2);
                    }
                }
                this.selectComList = Utils.merge([], selectComList);
            },
            changePriceSpecFlag: function (index) {
                let selectComList = this.selectComList || [];
                let selectCom = selectComList[index];
                // 按照服务项价格：清除-单价、总价
                if(selectCom.priceSpecFlag == 0) {
                    selectCom.price = 0.00;
                    selectCom.amount = 0.00;
                    selectCom.lastPrice = 0.00;
                } else if(selectCom.priceSpecFlag == 1) {
                    // 重算总价，防止四舍五入导致总价存在差异
                    let quantity = selectCom.quantity || 0;
                    let price = selectCom.price || 0.00;
                    selectCom.amount = parseFloat(quantity * price).toFixed(2);
                } else if(selectCom.priceSpecFlag == 2) {
                    let quantity = selectCom.quantity || 0;
                    let amount = selectCom.amount || 0.00;
                    if((this.servcModify || this.bianengFlag) && !Utils.isNoB(selectCom.amountUsed) && amount < selectCom.amountUsed2) {   // 修订
                        selectCom.amount = selectCom.amountUsed2;
                        MsgBox.warning("机构总价不可小于已发生总价：" + selectCom.amountUsed2);    // 只提示不 return ,继续执行下面的计算单价
                    }
                    if(quantity > 0 && amount > 0) {
                        let amountUsed2 = selectCom.amountUsed2 || 0.00;
                        let quantityUsed2 = selectCom.quantityUsed2 || 0;
                        selectCom.price = parseFloat((selectCom.amount - amountUsed2) / (selectCom.quantity - quantityUsed2)).toFixed(2);
                    }
                }
                this.selectComList = Utils.merge([], selectComList);
            },
            removeComInfo: function (index) {
                let selectComList = this.selectComList || [];
                selectComList.splice(index, 1);
                this.selectComList = Utils.merge([], selectComList);
            },
            setQuantity: function () {
                let self = this;
                let selectComList = this.selectComList || [];
                if(selectComList.length <= 0) {
                    MsgBox.warning("请先设置特定门店");
                    return false;
                }
                let validatorFunc = function (code, value, label, valuesMap) {
                    if(value < 0) {
                        return "数量不可小于0";
                    }
                };
                let theDlg = Vue.$showDialog({
                    title: "设置服务次数",
                    showCloseBtn: true,
                    width: 500,
                    height: 300,
                    template: '<swb-prop-editor ref="prop_editor" :title="editorTitle" :noGrid="true" :showBtnBar="false" :width="430" :widthForLabel="120" :propList="propList" :viewMode="false" :readOnly="false"></swb-prop-editor>',
                    data: {
                        editorTitle: "",
                        propList: [{
                            label: '设置服务次数', code: 'quantity', value: 0, valueType: 'Integer', tooltip: '', required: true, width: 300, validator: validatorFunc
                        }]
                    },
                    okClicked: function () {
                        let propEditor = this.$refs['prop_editor'];
                        if(propEditor.validate()) {
                            let postData = propEditor.getPropValues();
                            for(let i = 0; i < selectComList.length; i++) {
                                let orgQuantityInfo = selectComList[i];
                                orgQuantityInfo.quantity = postData.quantity;
                            }
                            self.selectComList = Utils.merge([], selectComList);
                            theDlg.close();
                        }
                        return false;
                    }
                });
            },
            // 价格预览
            showPriceRec: function (index) {
                let selectComList = this.selectComList || [];
                let selectCom = selectComList[index];
                let params = {
                    comnRequire: this.comnRequire,
                    originalServcItemId: selectCom.originalServcItemId,
                    bizUnitId: selectCom.bizUnitId,
                    amount: selectCom.amount,
                    servcQuantity: selectCom.quantity,
                    //
                    price: selectCom.price,
                    lastPrice: selectCom.lastPrice
                };
                openShowContractServcOrgPriceRecListDlg(params);
            },
            // 下载导入模板
            downloadTemplate: function () {
                let contractAppliedShopList = this.contractAppliedShopList || [];
                if(contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let bizUnitIds = contractAppliedShopList.pluck('shopId');
                let params = {
                    bizUnitIds: bizUnitIds,
                    amountFlag: this.amountFlag // 支持总价
                };
                let downloadUrl = Utils.makeUrl('/api/contract/servc/org/spec/imp/model/template/download', params);
                //
                Utils.setPageUrl(getAppUrl(downloadUrl), '_blank');
            },
            // 导入机构价格
            doUpload: function () {
                let self = this;
                let contractAppliedShopList = this.contractAppliedShopList || [];
                if(contractAppliedShopList.length <= 0) {
                    MsgBox.warning('请先选择适用机构');
                    return false;
                }
                let bizUnitIds = contractAppliedShopList.pluck('shopId');
                //
                let uploadParams = {
                    title: '特定门店价格导入',
                    fileFor: 'contract.servc.org.spec.import',
                    fileGroup: 'contract.servc.org.spec.import',
                    multipleFile: false
                };
                fileUploadGroupShowDlg(uploadParams, null, function (result, theDlg) {
                    theDlg.close();
                    if(result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join('<br/>'));
                            return;
                        }
                        //
                        let servcOrgSpecs = self.file.extra.servcOrgSpecList || [];
                        if(servcOrgSpecs.length <= 0) {
                            MsgBox.warning('文件中未解析到特定门店价格信息');
                            return;
                        }
                        //
                        let implBizUnitIdList = []; // 导入的业务单元ids
                        let servcOrgSpecMap = {};
                        let errMsg = '';
                        for(let i = 0; i < servcOrgSpecs.length; i++) {
                            let servcOrgSpec = servcOrgSpecs[i];
                            let bizUnitId = servcOrgSpec.bizUnitId;
                            let bizUnitName = servcOrgSpec.bizUnitName || '';
                            if(!bizUnitIds.contains(bizUnitId)) {
                                errMsg = bizUnitName + "不在合同的适用机构范围内，请移除！";
                                break;
                            }
                            implBizUnitIdList.add(bizUnitId);
                            servcOrgSpecMap[bizUnitId] = servcOrgSpec;
                        }
                        if(!Utils.isNoB(errMsg)) {
                            MsgBox.warning(errMsg);
                            return;
                        }
                        let selectComList = self.selectComList || []
                        let selectComIds = selectComList.pluck('bizUnitId');
                        let selectComMap = selectComList.toMap('bizUnitId');
                        let errorMsg = "";
                        for(let i = 0; i < servcOrgSpecs.length; i++) {
                            let servcOrgSpec = servcOrgSpecs[i];
                            let bizUnitId = servcOrgSpec.bizUnitId;
                            let comInfo = {};
                            if(selectComIds.contains(bizUnitId)) {
                                comInfo = selectComMap[bizUnitId];
                                //
                                if(!Utils.isTrue(self.servcModify) && !Utils.isTrue(self.bianengFlag)) {
                                    comInfo.priceSpecFlag = servcOrgSpec.priceSpecFlag;
                                } else {
                                    // 修订和变更时不覆盖价格规则
                                    // 总价不可小于已发生总金额
                                    let amount = servcOrgSpec.amount || 0.00;
                                    if(comInfo.priceSpecFlag == 2 && !Utils.isNoB(comInfo.amountUsed) && amount < comInfo.amountUsed) {
                                        errorMsg = comInfo.bizUnitName + "总价不可小于已发生总金额：" + comInfo.amountUsed;
                                        break;
                                    }
                                }
                            } else {
                                comInfo.bizUnitId = servcOrgSpec.bizUnitId;
                                comInfo.bizUnitName = servcOrgSpec.bizUnitName;
                                comInfo.shopFlag = servcOrgSpec.shopFlag;
                                comInfo.bizAreaId = servcOrgSpec.bizAreaId;
                                comInfo.bizAreaName = servcOrgSpec.bizAreaName;
                                comInfo.bizFormId = servcOrgSpec.bizFormId;
                                comInfo.bizFormName = servcOrgSpec.bizFormName;
                                comInfo.priceSpecFlag = servcOrgSpec.priceSpecFlag;
                            }
                            if(comInfo.priceSpecFlag == 0) {
                                comInfo.price = 0;
                                comInfo.amount = 0;
                            } else if(comInfo.priceSpecFlag == 1) {
                                comInfo.price = servcOrgSpec.price != null ? parseFloat(servcOrgSpec.price).toFixed(2) : null;
                                comInfo.amount = 0;
                            } else if(comInfo.priceSpecFlag == 2) {
                                comInfo.amount = servcOrgSpec.amount != null ? parseFloat(servcOrgSpec.amount).toFixed(2) : null;
                                // 计算单价
                                if(!Utils.isNoB(comInfo.quantity) && comInfo.quantity > 0) {
                                    comInfo.price = parseFloat(comInfo.amount / comInfo.quantity).toFixed(2);
                                }
                            }
                            selectComMap[bizUnitId] = comInfo;
                        }
                        if(!Utils.isNoB(errorMsg)) {
                            MsgBox.warning(errorMsg);
                            return;
                        }
                        let newComList = [];
                        for(let bizUnitId in selectComMap) {
                            newComList.push(selectComMap[bizUnitId]);
                        }
                        self.selectComList = Utils.merge([], newComList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            getDlgResult: function () {
                let self = this;
                let postData = {
                    type: 'info',
                    data: this.selectComList || []
                };
                let selectComList = this.selectComList || [];
                for(let i = 0; i < selectComList.length; i++) {
                    let selectComInfo = selectComList[i];
                    if(selectComInfo.priceSpecFlag == 1 && (Utils.isNoB(selectComInfo.price) || selectComInfo.price < 0.00)) {
                        postData.type = 'warn';
                        postData.message = "请填写单价";
                        break;
                    }
                    if(selectComInfo.priceSpecFlag == 2 && (Utils.isNoB(selectComInfo.amount) || selectComInfo.amount < 0.00)) {
                        postData.type = 'warn';
                        postData.message = "请填写机构总价";
                        break;
                    }
                }
                return postData;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcOrgSpecList.vue